/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import React from 'react';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
import useStyles from './style';

export interface NavLink {
  name: string;
  label: string;
  to: string;
  hasDrawer?: boolean;
  hideDivider?: boolean;
  hideMobile?: boolean;
  hideDesktop?: boolean;
  Component?: React.FC<any>;
}
export interface LinkDrawer {
  name: string;
  Component: React.FC;
  withStyle?: boolean;
}

export interface NavRootProps {
  navLinks?: NavLink[];
  mobileNavCTA?: React.ReactNode | string;
  linkDrawers?: LinkDrawer[];
  logoLink?: React.ReactNode | string;
  navLeft?: JSX.Element;
  navRight?: JSX.Element;
  cartCount?: number;
  showShopButton?: boolean;
  showCart?: () => void;
}

const NavRoot: React.FC<NavRootProps> = ({
  navLinks = [],
  mobileNavCTA,
  linkDrawers = [],
  logoLink,
  navLeft,
  navRight,
  cartCount,
  showShopButton = true,
  showCart,
  ...props
}) => {
  return (
    <nav
      className="px-cove-15 sm:px-cove-25 border-b-cove-dove sticky top-0 z-40 mx-auto my-0 w-full border-b bg-white py-0 lg:border-0 lg:border-none lg:p-0"
      id="page-header"
    >
      <div className="border-b-cove-dove hidden border-0 border-b lg:block">
        <DesktopNav
          navLinks={navLinks.filter(({ hideDesktop = false }) => !hideDesktop)}
          linkDrawers={linkDrawers}
          logoLink={logoLink}
          navLeft={navLeft}
          navRight={navRight}
          {...props}
        />
      </div>
      <div className="block lg:hidden">
        <MobileNav
          navLinks={navLinks
            .filter(({ hideMobile = false }) => !hideMobile)
            .slice(0, navLinks.length - 1)}
          logoLink={logoLink}
          mobileNavCTA={mobileNavCTA}
          navLeft={navLeft}
          navRight={navRight}
          {...props}
        />
      </div>
    </nav>
  );
};

NavRoot.propTypes = {
  navLinks: PropTypes.array,
  linkDrawers: PropTypes.array,
};

NavRoot.defaultProps = {
  navLinks: [],
  linkDrawers: [],
};

export default NavRoot;
